export default __webpack_public_path__ + "static/media/work_2.c49f5180.jpg";